import angular from 'angular';
import delegatedCardRequestComponent from './delegatedCardRequest.component';

let delegatedCardRequestModule = angular.module('delegatedCardRequest', [])

.component('delegatedCardRequest', delegatedCardRequestComponent)

.name;

export default delegatedCardRequestModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequest/delegatedCardRequest.js